import { createFileRoute } from "@tanstack/react-router";
import { isCompanyId, DEFAULT_COMPANY } from "../prototype/fixtures";
import { HomeScreen } from "../screens/HomeScreen";

export const Route = createFileRoute("/prototype/c/$companyId/home")({
  component: OwnerHome,
});

function OwnerHome() {
  const { companyId } = Route.useParams();
  return <HomeScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} />;
}
